import React, { useEffect, useMemo } from 'react';
import useI18n from 'i18n/useI18n';
import { useHistory, useParams } from 'react-router-dom';
import Table from 'components/Table';
import structure from './structure';
import useRoles from 'state/roles';
import ManagementTabsContainer from 'pages/Group/pages/Management/containers/ManagementTabsContainer';
import { useAlert } from '@etiquette-ui/alert-dialog';
import { useSearch } from 'providers/search';
import { compareStrings } from 'utils';
import { useAccess } from 'providers/access';
import { ACCESS_LIST } from 'resources/constants/config';
import useUsers from 'state/users';
import useDivisions from 'state/divisions';

const List = ({ location }) => {
  const history = useHistory();
  const { translate } = useI18n();
  const { groupId } = useParams();
  const [data, dispatcher] = useRoles();
  const alert = useAlert();
  const { search, setVisible } = useSearch();
  const { hasAccessInGroup } = useAccess();
  const [users, usersDispatcher] = useUsers();
  const [, divisionDispatcher] = useDivisions();

  useEffect(() => {
    dispatcher.fetchStart(groupId);
    usersDispatcher.fetchStart(groupId);
    divisionDispatcher.fetchStart(groupId);
  }, [groupId, users.list]);

  useEffect(() => {
    setVisible(true);
    return () => setVisible(false);
  }, []);

  const items = useMemo(() => {
    let list = [...data.list];
    if (search.length !== 0) list = list.filter(({ name }) => compareStrings(name, search));
    return list;
  }, [data.list, search]);

  return (
    <ManagementTabsContainer location={location} fabLink={`${location.pathname}/create`} fabText={translate('Add Role')} fabDisabled={!hasAccessInGroup(groupId, ACCESS_LIST.ROLE)}>
      <Table structure={structure} config={{ history, dispatcher, data, translate, groupId, alert }} items={items.filter((app) => +groupId === app.groupId)} />
    </ManagementTabsContainer>
  );
};

export default List;
